import { uuid } from "../utils/FPEUtils";
import { useSetRecoilState } from "recoil";
import { addAlertStateSelector, removeAlertStateSelector } from "../store/AlertState";

export const useAlert = () => {

  const addAlert = useSetRecoilState(addAlertStateSelector);
  const removeAlert = useSetRecoilState(removeAlertStateSelector);

  /**
   * @typedef {Object} defaultOption
   * @property {Array.<string>} [position=['top','center]] 表示位置
   * @property {number} [timeout=0] 自動削除までの時間(単位msec) 0は自動削除しない
   * @property {number} [verticalOffset=25] 縦表示位置のオフセット
   * @property {number} [horizontalOffset=25] 横表示位置のオフセット(centerを指定した場合は無視)
   * @property {boolean} [close=true] 削除ボタンの表示
   */
  const defaultOption = {
    position: alertPosition.TOP_CENTER,
    timeout: 0,
    verticalOffset: 25,
    horizontalOffset: 25,
    close: true
  };

  const _alertInfo = (type, text, opt = {}) => {
    const id = uuid();
    const option = {...defaultOption, ...opt};
    const alertInfo = {
      id,
      type,
      text,
      option
    };

    addAlert(alertInfo);

    if (option.timeout) {
      setTimeout(() => {
        removeAlert(alertInfo);
      }, option.timeout);
    }
  };

  /**
   * Info Alertの表示
   * @param {string} text 表示テキスト
   * @param {defaultOption} [option]
   */
  const info = (text, option) => {
    _alertInfo('info', text, option);
  };

  /**
   * Success Alertの表示
   * @param {string} text 表示テキスト
   * @param {defaultOption} [option]
   */
  const success = (text, option) => {
    _alertInfo('success', text, option);
  };

  /**
   * Warning Alertの表示
   * @param {string} text 表示テキスト
   * @param {defaultOption} [option]
   */
  const warning = (text, option) => {
    _alertInfo('warning', text, option);
  };

  /**
   * Error Alertの表示
   * @param {string} text 表示テキスト
   * @param {defaultOption} [option]
   */
  const error = (text, option) => {
    _alertInfo('error', text, option);
  };

  return {
    showInfo : info,
    showSuccess: success,
    showWarning: warning,
    showError: error
  };
};

export const alertPosition = {
  TOP_LEFT: ['top', 'left'],
  TOP_CENTER: ['top', 'center'],
  TOP_RIGHT: ['top', 'right'],
  BOTTOM_LEFT: ['bottom', 'left'],
  BOTTOM_CENTER: ['bottom', 'center'],
  BOTTOM_RIGHT: ['bottom', 'right']
};
